import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchAuthSession } from '@aws-amplify/auth';
import axios from 'axios';
import AchievementNotification from './components/AchievementNotification';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [skillsList, setSkillsList] = useState(null);
  const [dmtSkillsList, setDmtSkillsList] = useState(null);
  const [tumbleSkillsList, setTumbleSkillsList] = useState(null);
  const [isTokenReady, setIsTokenReady] = useState(false);

  // Achievement queue
  const [achievementQueue, setAchievementQueue] = useState([]);
  const [currentAchievement, setCurrentAchievement] = useState(null);

  useEffect(() => {
    const fetchJwtToken = async () => {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens.idToken;
        axios.defaults.headers['Authorization'] = `Bearer ${token}`;
        setIsTokenReady(true);
      } catch (error) {
        console.error('Error fetching JWT token:', error);
        setIsTokenReady(true);
      }
    };

    fetchJwtToken();
  }, []);

  useEffect(() => {
    if (isTokenReady) {

      axios.get(process.env.REACT_APP_API_HOST + '/api/skills/trampoline')
        .then(response => {
          if (response.data !== null) setSkillsList(response.data);
        })
        .catch(error => console.error('Error fetching all trampoline skills:', error));

      axios.get(process.env.REACT_APP_API_HOST + '/api/skills/dmt')
        .then(response => {
          if (response.data !== null) setDmtSkillsList(response.data);
        })
        .catch(error => console.error('Error fetching all dmt skills:', error));

      axios.get(process.env.REACT_APP_API_HOST + '/api/skills/tumbling')
        .then(response => {
          if (response.data !== null) setTumbleSkillsList(response.data);
        })
        .catch(error => console.error('Error fetching all tumbling skills:', error));

    }
  }, [isTokenReady]);

  // Drain the queue — show next achievement when current closes
  const handleAchievementClose = useCallback(() => {
    setCurrentAchievement(null);
    setAchievementQueue(prev => {
      const [next, ...rest] = prev;
      if (next) setTimeout(() => setCurrentAchievement(next), 300);
      return rest;
    });
  }, []);

  // Call this after any API response that may contain new_achievements
  const triggerAchievements = useCallback((newAchievements) => {
    if (!newAchievements?.length) return;
    setAchievementQueue(prev => {
      const combined = [...prev, ...newAchievements];
      // If nothing is currently showing, pop the first one immediately
      if (!currentAchievement) {
        const [first, ...rest] = combined;
        setCurrentAchievement(first);
        return rest;
      }
      return combined;
    });
  }, [currentAchievement]);

  return (
    <DataContext.Provider value={{ skillsList, dmtSkillsList, tumbleSkillsList, triggerAchievements }}>
      {children}
      <AchievementNotification
        achievement={currentAchievement}
        onClose={handleAchievementClose}
      />
    </DataContext.Provider>
  );
};

export const useData = () => {
  return useContext(DataContext);
};